import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useState } from 'react';
import PhoneInput from '../../components/inputs/phone';
import { ClearButton, CustomButton } from '../../components/buttons';
import Skeleton from '@mui/material/Skeleton';
import { post } from '../../core/client';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import CreateMvkReservationComponent from './create-mvk-reservation';
import ListMvkReservationComponent from './list-mvk-reservation-info';
import DatePicker from '../../components/inputs/date-picker';

interface ReportMvkReservationRequest {
    beginDate: string | null;
    endDate: string | null;
}

const initialReqState: ReportMvkReservationRequest = {
    beginDate: "",
    endDate: "",
}

const initialReqToLoadState: ReportMvkReservationRequest = {
    beginDate: null,
    endDate: null,
}

const ReportMvkReservationComponent = () => {

    const [requestState, setRequestState] = useState<ReportMvkReservationRequest>(initialReqState);
    const [requestStateToLoad, setRequestStateToLoad] = useState<ReportMvkReservationRequest>(initialReqToLoadState);
    const [loading, setLoading] = useState(false);

    const handleRequestChange = (e: any) => {
        setRequestState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    const handleResetForm = () => {
        setRequestState(initialReqState);
        setRequestStateToLoad(initialReqToLoadState);
    };

    const handleListReservations = () => {
        setRequestStateToLoad(requestState);
    }

    const renderContent = () => {
        return (
            <Grid container xl spacing={3}>
                <Grid item md={12}>
                    <div className="widget-area" style={{ height: '100%' }}>
                        <ListMvkReservationComponent memberId={null} isReport={true} onLoading={setLoading} beginDate={requestStateToLoad.beginDate} endDate={requestStateToLoad.endDate} />
                    </div>
                </Grid>
            </Grid>
        );
    };

    return (
        <>
            <div className="page-header">
                <div className="page-title">
                    <h2>MVK Rezervasyon Rapor Listesi</h2>
                </div>
            </div>

            <div className="page-content">
                <Grid container direction="column" alignItems="center">
                    <Box className="member-search" p={2}>
                        <Box className="form-field" mb={2}>
                            <DatePicker
                                id="beginDate"
                                caption="Başlangıç Tarihi"
                                name="beginDate"
                                value={requestState.beginDate}
                                onChange={handleRequestChange} />
                        </Box>
                        <Box className="form-field" mb={2}>
                            <DatePicker
                                id="endDate"
                                caption="Bitiş Tarihi"
                                name="endDate"
                                value={requestState.endDate}
                                onChange={handleRequestChange} />
                        </Box>
                        <Grid container spacing={1} justifyContent="center">
                            <Grid item>
                                <CustomButton
                                    text="Sorgula"
                                    className='ks-btn btn-primary'
                                    disabled={loading}
                                    loading={loading}
                                    onClick={handleListReservations}
                                />
                            </Grid>
                            <Grid item>
                                <ClearButton
                                    disabled={loading || (requestState.beginDate === '' && requestState.endDate === '') }
                                    onClick={() => handleResetForm()}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    {renderContent()}
                </Grid>
            </div>
        </>
    )

};

export default ReportMvkReservationComponent;